import { createRouter, createWebHistory } from 'vue-router'


declare module 'vue-router' {
  interface RouteMeta {
    favicon?: string
    title?: string
  }
}

export const ROUTE_MAP = {
  published: 'published',
  canvas: 'canvas',
  newsEditor: 'newsEditor',
  newsEditorById: 'newsEditorById',
  embargo: 'embargo',
  search: 'search',
  resetPasswordComplete: 'resetPasswordComplete',
} as const

const ONLY_NUMBER_REG_EXP = '(\\d+)'
const OPTIONAL_PARAM = '?'

export const router = createRouter({
  history: createWebHistory(),

  routes: [
    {
      path: '/',
      redirect: { name: 'legacy', params: {} },
    },

    /* WORKSPACE ROUTES */

    {
      path: '/published',
      name: ROUTE_MAP.published,
      component: () => import('@/views/PublishedWorkspace.vue'),
      meta: {
        favicon: 'published.png',
        title: 'Выпущено',
      },
    },
    {
      path: '/editor',
      redirect: { name: ROUTE_MAP.newsEditorById },
      name: ROUTE_MAP.newsEditor,
      meta: {
        favicon: 'editor.png',
        title: 'Редактор',
      },
      children: [
        {
          path: ':id' + ONLY_NUMBER_REG_EXP + OPTIONAL_PARAM,
          name: ROUTE_MAP.newsEditorById,
          component: () => import('@/views/NewsEditor.vue'),
        },
      ],
    },
    {
      path: '/canvas',
      name: ROUTE_MAP.canvas,
      component: () => import('@/views/CanvasEditor.vue'),
      meta: {
        favicon: 'canvas.png',
        title: 'Холст',
      },
    },
    {
      path: '/embargo',
      name: ROUTE_MAP.embargo,
      component: () => import('@/views/EmbargoWorkspace.vue'),
      meta: {
        favicon: 'embargo.png',
        title: 'Эмбарго',
      },
    },
    {
      path: '/search',
      name: ROUTE_MAP.search,
      component: () => import('@/views/SearchWorkspace.vue'),
      meta: {
        favicon: 'search.png',
        title: 'Поиск',
      },
    },

    /* OTHER ROUTES */

    {
      path: '/reset-password/:token',
      name: ROUTE_MAP.resetPasswordComplete,
      component: () => import('@/views/PublishedWorkspace.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      // При редиректе без указания params появляется ворнинг. Передача пустого объекта params - способ обойти
      // появление ворнинга (https://github.com/vuejs/router/issues/1617#issuecomment-1320941431)
      redirect: { name: ROUTE_MAP.published, params: {} },
    },
    {
      path: '/new',
      redirect: { name: ROUTE_MAP.published, params: {} },
    },

    /* LEGACY ROUTES */

    {
      path: '/legacy',
      component: () => import('@/ContextTab/modules/legacy/Legacy.vue'),
      name: 'legacy',
    },
    {
      path: '/legacy:legacyPath(.*)',
      component: () => import('@/ContextTab/modules/legacy/Legacy.vue'),
      name: 'legacyInternal',
    },
    {
      path: '/tasks',
      redirect: { name: 'legacy', params: {} },
    },
    {
      path: '/entities',
      redirect: { path: 'legacy/entities' },
      name: 'entities',
    },

  ],
})
